export const defaultProjects = [
  {
    id: 1,
    cat: 'identite',
    catLabel: 'Identité Visuelle',
    name: 'NOVA STUDIO',
    desc: "Refonte complète de l'identité visuelle d'un studio créatif parisien spécialisé dans la photographie de mode. L'objectif : une marque sobre et audacieuse, capable de s'exprimer aussi bien en digital que print.",
    bg: 'project-bg-1',
    letter: 'N',
    client: 'Nova Studio Paris',
    date: 'Mars 2025',
    role: 'Direction artistique, Design de logo, Charte graphique',
    tools: ['Illustrator', 'Figma', 'InDesign'],
    context: "Nova Studio souhaitait se repositionner sur le marché du luxe après 5 ans d'activité. L'ancienne identité ne reflétait plus l'ambition de la maison ni son positionnement tarifaire.",
    approach: "Après un audit complet de la marque et des entretiens avec l'équipe fondatrice, nous avons défini un territoire visuel autour de la tension entre rigueur et sensibilité. Le logo combine un monogramme géométrique et une typographie sur-mesure exclusive.",
    result: "Déploiement sur tous les supports en 4 semaines. Retours clients positifs et repositionnement tarifaire réussi dans les 3 mois suivant le lancement de la nouvelle identité.",
    heroImage: '',
    heroLetter: 'N',
    heroBg: 'linear-gradient(135deg, #130508 0%, #2a0d12 50%, #130508 100%)',
    images: ['', '', '', '', ''],
    imageBgs: [
      'linear-gradient(135deg,#1a0808,#3d1010)',
      'linear-gradient(135deg,#0a0a1a,#18182e)',
      'linear-gradient(135deg,#0a1a0a,#102810)',
      'linear-gradient(135deg,#1a1a0a,#282808)',
      'linear-gradient(135deg,#1a0a1a,#280e28)',
    ],
  },
  {
    id: 2,
    cat: 'ui',
    catLabel: 'UI / UX Design',
    name: 'FLUX APP',
    desc: "Conception de l'interface d'une application de productivité B2B pour équipes créatives. Le projet couvrait la totalité du parcours utilisateur, du onboarding à la gestion de projet avancée.",
    bg: 'project-bg-2',
    letter: 'F',
    client: 'Flux Technologies',
    date: 'Janvier 2025',
    role: 'UI Design, Design System, Prototypage',
    tools: ['Figma', 'Framer', 'Notion'],
    context: "La startup Flux avait un produit fonctionnel mais une interface datée qui freinait l'adoption. L'enjeu : moderniser sans déstabiliser les utilisateurs existants tout en posant les bases d'un design system scalable.",
    approach: "Audit UX complet, ateliers de co-conception avec les équipes produit, puis itérations rapides en Figma. Livraison d'un design system complet avec plus de 200 composants documentés et une bibliothèque de tokens.",
    result: "Amélioration du taux de rétention de +34% à 3 mois post-launch. Le design system est aujourd'hui maintenu en interne par l'équipe Flux.",
    heroImage: '',
    heroLetter: 'F',
    heroBg: 'linear-gradient(135deg, #060814 0%, #0e1228 50%, #060814 100%)',
    images: ['', '', '', '', ''],
    imageBgs: [
      'linear-gradient(135deg,#0a0a1a,#18182e)',
      'linear-gradient(135deg,#1a0a1a,#280e28)',
      'linear-gradient(135deg,#0a1a1a,#0e2828)',
      'linear-gradient(135deg,#1a1a0a,#282808)',
      'linear-gradient(135deg,#1a0808,#3d1010)',
    ],
  },
  {
    id: 3,
    cat: 'motion',
    catLabel: 'Motion Design',
    name: 'SURGE BRAND',
    desc: "Création d'une identité animée complète pour une marque de sport haut de gamme : intro logo, transitions, templates réseaux sociaux animés, et manifeste vidéo de marque.",
    bg: 'project-bg-3',
    letter: 'S',
    client: 'Surge Sportswear',
    date: 'Novembre 2024',
    role: 'Motion Design, Direction artistique, Animation',
    tools: ['After Effects', 'Cinema 4D', 'Illustrator'],
    context: "Surge lançait une nouvelle gamme premium et avait besoin d'assets motion pour une campagne de lancement digital-first sur Instagram et TikTok.",
    approach: "Développement d'un langage motion cohérent basé sur l'énergie cinétique et la précision. Chaque animation respecte une même grammaire : accélérations rapides, décélérations douces, jamais de rebond.",
    result: "La campagne de lancement a généré 2,4M d'impressions organiques en 2 semaines. Les templates sont réutilisés in-house pour toutes les communications de la marque.",
    heroImage: '',
    heroLetter: 'S',
    heroBg: 'linear-gradient(135deg, #061308 0%, #0e2812 50%, #061308 100%)',
    images: ['', '', '', '', ''],
    imageBgs: [
      'linear-gradient(135deg,#0a1a0a,#102810)',
      'linear-gradient(135deg,#1a0a0a,#2d1212)',
      'linear-gradient(135deg,#0a0a1a,#18182e)',
      'linear-gradient(135deg,#1a1a0a,#282808)',
      'linear-gradient(135deg,#1a0a1a,#280e28)',
    ],
  },
  {
    id: 4,
    cat: 'print',
    catLabel: 'Print & Édition',
    name: 'REVUE NOIRE',
    desc: "Direction artistique et mise en page d'une revue culturelle trimestrielle axée sur les arts contemporains et la photographie. 120 pages, 3 numéros réalisés à ce jour.",
    bg: 'project-bg-4',
    letter: 'R',
    client: 'Éditions du Soir',
    date: 'Septembre 2024',
    role: 'Direction artistique, Mise en page, Typographie',
    tools: ['InDesign', 'Illustrator', 'Photoshop'],
    context: "Les Éditions du Soir lançaient un nouveau titre ambitieux, à mi-chemin entre magazine et livre d'art, ciblant un lectorat cultivé et exigeant en kiosques et librairies.",
    approach: "Construction d'une grille éditoriale modulaire permettant rigueur et surprise. Sélection d'une combinaison typographique exclusive et développement d'un système de rubriques visuellement distinctif.",
    result: "Les trois numéros ont été épuisés en kiosque dès la première semaine. La revue a été sélectionnée pour le prix de la Meilleure Publication Culturelle 2024.",
    heroImage: '',
    heroLetter: 'R',
    heroBg: 'linear-gradient(135deg, #131308 0%, #252508 50%, #131308 100%)',
    images: ['', '', '', '', ''],
    imageBgs: [
      'linear-gradient(135deg,#1a1a0a,#282808)',
      'linear-gradient(135deg,#0a1a0a,#102810)',
      'linear-gradient(135deg,#1a0a0a,#2d1212)',
      'linear-gradient(135deg,#0a0a1a,#18182e)',
      'linear-gradient(135deg,#1a0a1a,#280e28)',
    ],
  },
  {
    id: 5,
    cat: 'illustration',
    catLabel: 'Illustration',
    name: 'ATLAS VISUEL',
    desc: "Série de 12 illustrations originales pour une campagne publicitaire digitale d'une agence de voyage haut de gamme. Chaque illustration représente une destination avec un style reconnaissable.",
    bg: 'project-bg-5',
    letter: 'A',
    client: 'Atlas Agency',
    date: 'Juillet 2024',
    role: 'Illustration digitale, Direction artistique',
    tools: ['Procreate', 'Illustrator', 'Photoshop'],
    context: "Atlas Agency souhaitait rompre avec les photos stock et proposer une communication visuelle unique et forte sur les réseaux sociaux.",
    approach: "Développement d'un style illustratif propre mêlant géométrie et couleurs saturées, inspiré des affiches de voyage des années 50 réinterprétées de manière contemporaine et digitale.",
    result: "Les illustrations ont généré un taux d'engagement 3× supérieur aux visuels précédents. Le style est aujourd'hui l'identité visuelle principale de la marque Atlas.",
    heroImage: '',
    heroLetter: 'A',
    heroBg: 'linear-gradient(135deg, #130813 0%, #280e28 50%, #130813 100%)',
    images: ['', '', '', '', ''],
    imageBgs: [
      'linear-gradient(135deg,#1a0a1a,#280e28)',
      'linear-gradient(135deg,#1a0a0a,#2d1212)',
      'linear-gradient(135deg,#0a1a1a,#0e2828)',
      'linear-gradient(135deg,#1a1a0a,#282808)',
      'linear-gradient(135deg,#0a0a1a,#18182e)',
    ],
  },
];

export function getProjects() {
  return JSON.parse(localStorage.getItem('projects') || 'null') || defaultProjects;
}
